import { ColumnWidthOutlined, InboxOutlined } from '@ant-design/icons';
import { Form, Input, message, Upload, Checkbox } from 'antd';
import JoditEditor from 'jodit-react';
import React, { useRef, useState } from 'react';
import { ViewDocument } from '../../../components';


function OpenQuestion({
  dictionary,
  language,
  form,
  Answers,
  currentSubject: currentQuestion,
  questionAnswerFiles,
  setQuestionAnswerFiles,
}) {

  if (currentQuestion) {
    form.setFieldsValue({
      answerHtml: currentQuestion.answerVariants[0].answerHtml,
      answerId: currentQuestion.answerVariants[0].id,
    });
  }

  console.log("AA", Answers);
  if (Answers) {
    form.setFieldsValue({
      answerHtml: Answers[0].answerHtml,
      answerId: Answers[0].id
    })
  }

  const editor = useRef(null);
  const [withFile, setWithFile] = useState(false);
  const [fileLists, setFileLists] = useState([]);

  const config = {
    readonly: false,
    limitChars: 2000,
    placeholder: '',
  };

  function prepareFiles(file) {
    file.onSuccess('ok');
  }

  return (
    <React.Fragment>
      {currentQuestion && (
        <Form.Item name="answerId" style={{ display: 'none' }}>
          <Input type="hidden" />
        </Form.Item>
      )}
      <Form.Item
        name="answerHtml"
        label={dictionary?.RightAnswer[language]}
        rules={[
          {
            required: true,
          },
          {
            max: 2000,
            type: 'string',
            message: `${dictionary?.MaxCharacterCount[language].replace('%s', 2000)}`,
          },
        ]}>
        <JoditEditor ref={editor} config={config} tabIndex={1} />
      </Form.Item>
      { Answers && Answers[0].files.length > 0 &&
        <Form.Item label={dictionary?.File[language]}>
          <ViewDocument files={Answers[0].files} />
        </Form.Item>
      }
      { !Answers && <Form.Item
        name="answerFile"
        label={
          <div>
            {dictionary?.AttachFile[language]} :
            <Checkbox
              onChange={(e) => setWithFile(e.target.checked)}
              checked={withFile}
              size="large"
            />
          </div>
        }
        colon={false}>
        <Upload.Dragger
          customRequest={(e) => prepareFiles(e)}
          maxCount={2}
          disabled={!withFile}
          multiple={true}
          style={{ height: '15px', width: '100%' }}
          onChange={({ file, fileList }) => {
            if (file.status === 'removed') {
              setFileLists(fileLists.filter((f) => f.index !== file.index));
              setQuestionAnswerFiles(questionAnswerFiles.filter((f) => f.uid !== file.file.uid));
            } else if (file.status === 'done') {
              if (file.size <= 5000000) {
                if (fileLists.length < 2) {
                  setQuestionAnswerFiles([...questionAnswerFiles, file]);
                  setFileLists([
                    ...fileLists,
                    {
                      file: file,
                      name: file.name,
                      index: fileLists.length,
                      uid: Date.now().toString(),
                    },
                  ]);
                  form.setFieldsValue({ questionAnswerFile: [...fileLists, file] });
                } else {
                  message.error('Максимум 2 файла');
                }
              } else {
                message.error('Не больше 5 МВ');
              }
            }
          }}
          fileList={fileLists}>
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <p className="ant-upload-text">{dictionary?.MaxFile[language]}</p>
        </Upload.Dragger>
      </Form.Item>
      }
    </React.Fragment>
  );
}

export default OpenQuestion;
